import api, { fetchData } from "./api";
import CargoDocumentType from "../types/cargoDocumentType";
import Paginacao from "../types/paginacao";

export interface CargoDocumentTypeVM {
    version: number;
    key: string;
    description: string;
}

export interface CargoDocumentTypeApiResponse {
    data: CargoDocumentType;
    messages: any; 
}

export const getListaCargoDocumentType = async () => {
    try {
        const endpoint: string = "/CargoDocumentType/all";
        const response = await fetchData<CargoDocumentType>(endpoint, {});
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar lista de cargoDocumentType:", error);
        throw error;
    }
};

export const getListaCargoDocument = async () => {
    try {
        const endpoint: string = "/CargoDocumentType/all";
        const response = await fetchData<CargoDocumentType>(endpoint, {});
        return response;
    } catch (error) {
        console.error("Erro ao buscar lista de cargoDocumentType:", error);
        throw error;
    }
};

export const getListaCargoDocumentTypePaginated = async (
    paginacao: Paginacao
) => {
    try {
        const endpoint: string = "/CargoDocumentType/all/paginado";
        const params: Record<string, any> = {
            pageNum: paginacao.pageNum + 1,
            quantityPerPage: paginacao.quantityPerPage,
            order: paginacao.order,
            sort: paginacao.sort,
        };
        const response = await fetchData<CargoDocumentType>(endpoint, params);
        return response;
    } catch (error) {
        console.error("Erro ao buscar lista de cargoDocumentType:", error);
        throw error;
    }
};

export const getCargoDocumentTypeById = async (id: number) => {
    try {
        const response = await api.get<CargoDocumentTypeApiResponse>(`/CargoDocumentType/${id}`);
        return response.data; 
    } catch (error) {
        console.error(`Erro ao buscar cargoDocumentType com ID ${id}`, error);
        throw error;
    }
};

export const createCargoDocumentType = async (cargo: CargoDocumentTypeVM) => {
    try {
        const response = await api.post<CargoDocumentTypeApiResponse>("/CargoDocumentType", cargo);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar cargoDocumentType:", error);
        throw error;
    }
};

export const updateCargoDocumentType = async (id: number, cargo: CargoDocumentType) => {
    try {
        const response = await api.put<CargoDocumentTypeApiResponse>(`/CargoDocumentType/${id}`, cargo);
        return response.data;
    } catch (error) {
        console.error(`Erro ao atualizar cargoDocumentType com ID ${id}:`, error);
        throw error;
    }
};

export const deleteCargoDocumentType = async (id: number) => {
    try {
        await api.delete(`/CargoDocumentType/${id}`);
        return true;
    } catch (error) {
        console.error(`Erro ao excluir cargoDocumentType com ID ${id}:`, error);
        throw error;
    }
};
